import { TOptimizarFondosPayload, TOptimizarFondosResultados, TRatiosKeyCompletos } from "../../../services/OmniaService";
import { CartLinesFromDB } from "../../../services/PortfolioModelWalletService";
import { TTableData } from "../Simulation";
import { ReplaceWeightToNumber } from "./ReplaceNumbersFunctions";

export const FormatFundsData = (funds: CartLinesFromDB[]) => {
    const sumatory = funds.reduce((acc, fund) => acc + (ReplaceWeightToNumber(fund.weight) ?? 0), 0);
    
	const mappedData: TTableData[] = funds.map(fund => {
		const originalW = (ReplaceWeightToNumber(fund.weight) / sumatory) * 100;
		const destinyW = (ReplaceWeightToNumber(fund.weight) / sumatory) * 100;
		return {
			originalIsin: fund.isin,
			originalWeight: originalW,
			originalName: fund.name,
			destinyIsin: "",
			destinyName: "",
			destinyWeight: destinyW,
			posicion_fondo_original: 0,
			total_fondos_categoria: 0,
			ratiosCompletos: {
				fondo_original: {} as TRatiosKeyCompletos,
				fondo_nuevo: {} as TRatiosKeyCompletos
			}
		};
	});
     return mappedData.sort((a, b) => b.originalWeight - a.originalWeight);
 };

export const FormatDestinyFundsData = (destiny: TOptimizarFondosResultados[], originalFunds: TTableData[], payload: TOptimizarFondosPayload) => {
    return originalFunds.map(originalFund => {
        const match = destiny.find(fund => fund.isin_original === originalFund.originalIsin && fund.nombre_fondo_original === originalFund.originalName);

        if (!match) return originalFund;

        const destinyDataMapped: TTableData = {
            ...originalFund,
            destinyName: match?.nombre_fondo_nuevo,
            destinyIsin: match?.isin_nuevo,
            total_fondos_categoria: match.total_fondos_categoria,
            posicion_fondo_original: match.posicion_fondo_original,
            ratiosCompletos: {
                fondo_nuevo: { 
                    ...match?.ratios_completos?.fondo_nuevo,
                    ...(payload.ratio === "gastos_corrientes" ? { gastos_corrientes: match.valor_ratio_nuevo } : {}),
                    ...(payload.ratio === "pca" ? { pca: match.valor_ratio_nuevo } : {}),
                    ...(payload.ratio === "clase_limpia" ? { clase_limpia: match.valor_ratio_nuevo  } : {}),
                },
                fondo_original: {
                    ...match?.ratios_completos?.fondo_original,
                    ...(payload.ratio === "gastos_corrientes" ? { gastos_corrientes: match.valor_ratio_original } : {}),
                    ...(payload.ratio === "pca" ? { pca: match.valor_ratio_original } : {}),
                    ...(payload.ratio === "clase_limpia" ? { clase_limpia: match.valor_ratio_original  } : {}),
                }
            }
        };

        return destinyDataMapped;
    });
};
